import { render, staticRenderFns } from "./ScrollToTopIcon.vue?vue&type=template&id=35646f6c&scoped=true"
import script from "./ScrollToTopIcon.vue?vue&type=script&lang=js"
export * from "./ScrollToTopIcon.vue?vue&type=script&lang=js"
import style0 from "./ScrollToTopIcon.vue?vue&type=style&index=0&id=35646f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35646f6c",
  null
  
)

export default component.exports